<template>
  <v-container class="my-12">
    <!-- Sección principal -->
    <v-row align="center" justify="center">
      <!-- Imagen -->
      <v-col cols="12" md="5">
        <v-img
          :src="require('@/assets/equipo.jpg')"
          alt="Nuestro equipo de capacitación"
          class="elevation-5"
          height="350px"
          contain
        ></v-img>
      </v-col>

      <!-- Texto -->
      <v-col cols="12" md="7">
        <h2 class="display-1 font-weight-bold mb-4 purple--text text--darken-2">
          Sobre Nosotros
        </h2>

        <p class="subtitle-1 mb-4">
          En <strong>Consultora Innova A&G</strong>, nos especializamos en la formación
          tecnológica de alto nivel, con un enfoque en lenguajes y entornos clave como
          <strong>Java, .NET, Python</strong> y otras tecnologías emergentes. Nuestra
          misión es brindar a profesionales y organizaciones las herramientas necesarias
          para enfrentar los retos del entorno digital, mediante programas de capacitación
          prácticos, actualizados y alineados con las necesidades reales del mercado.
        </p>

        <p class="subtitle-1 mb-4">
          Nuestros programas están diseñados para formar perfiles altamente demandados
          como:
          <strong
            >Desarrolladores Full Stack, Ingenieros de Datos (Data Engineers), Arquitectos
            Cloud, Especialistas en DevOps, Analistas de Datos, Profesionales en IA y
            Ciberseguridad</strong
          >. Cada curso se enfoca en la aplicación de habilidades técnicas mediante
          proyectos reales, simulaciones de entornos productivos y herramientas utilizadas
          en la industria.
        </p>

        <p class="subtitle-1 mb-6">
          Contamos con
          <strong>instructores certificados y con experiencia en la industria</strong>, lo
          que garantiza una formación aplicable desde el primer día. Nuestra metodología
          se basa en el <strong>aprendizaje 100% práctico</strong>, facilitando el
          desarrollo de competencias técnicas y estratégicas en cada participante.
        </p>

        <router-link to="/cursos">
          <v-btn color="deep-purple" large rounded elevation="2" class="mr-4">
            Conoce nuestros cursos
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

    <!-- Sección Únete a nuestra familia -->
    <v-row class="mt-12" align="center" justify="center">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold mb-4 orange--text text--darken-2">
          ¡Únete a nuestra familia!
        </h2>
        <p class="subtitle-1 mb-6">
          Si eres un <strong>profesional con experiencia</strong> en áreas como desarrollo
          de software, ingeniería de datos, análisis de datos, cloud computing,
          inteligencia artificial, ciberseguridad o automatización de procesos, te
          invitamos a formar parte de nuestro equipo académico. Comparte tu conocimiento,
          impulsa el crecimiento de nuevos talentos y contribuye a
          <strong>expandir nuestra propuesta tecnológica a nivel regional</strong>.
        </p>
        <v-btn color="orange darken-2" large rounded elevation="2">
          Postula con nosotros
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "NosotrosPage",
};
</script>

<style scoped>
h2 {
  letter-spacing: -1px;
}
.subtitle-1 {
  line-height: 1.7;
}
</style>
